import config from '../config';
import selectedEnvironment from '../env';
const API_URL = `${config[selectedEnvironment].API_URL}/Accountants`;
const API_URL_SubAccountant = `${config[selectedEnvironment].API_URL}/SubAccountants`;
// Function to update user information
const UpdateUser = async (accountantId, token) => {
    try {
        
        const response = await fetch(`${API_URL}/${accountantId}`, {
            method: 'GET',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        localStorage.setItem('user', JSON.stringify(data));
        return data;
    } catch (error) {
    }
};

const addClient = async (clientData, token) => {
    const response = await fetch(`${API_URL}/CreateClient`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Authorization": 'Bearer ' + token,
        },
        body: JSON.stringify(clientData),
    });

    if (!response.ok) {
        const errorBody = await response.text(); // Get the response text
        throw new Error(`Failed to add client: ${errorBody}`);
    }

    return response;
}


// Function to get the current logged-in user
const getCurrentUser = () => {
    const user = localStorage.getItem('user');
    return user != null ? JSON.parse(user) : null;
};

// Function to get the current token
const getCurrentToken = () => {
    const token = localStorage.getItem('token');
    return token != null ? JSON.parse(token) : null;
};

// Function to get the current token
const getCurrentUserType = () => {
    const userType = localStorage.getItem('userType');
    return userType != null ? JSON.parse(userType) : null;
};

const EditUser = async (token, user) => {
    try {
        const response = await fetch(`${API_URL}/Update`, {
            method: 'PUT',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ ...user })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};

const EditSubAccountant = async (token, user) => {
    try {
        const response = await fetch(`${API_URL_SubAccountant}/Update`, {
            method: 'PUT',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ ...user })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};

const addSubAccountant = async (subAccountantData, token) => {
    const response = await fetch(`${API_URL_SubAccountant}/Create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Authorization": 'Bearer ' + token,
        },
        body: JSON.stringify(subAccountantData),
    });

    if (!response.ok) {
        const errorBody = await response.text(); // Get the response text
        throw new Error(`Failed to add client: ${errorBody}`);
    }

    // Check if the response is JSON
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
    } else {
        return response.text(); // If not JSON, just return the text response
    }
}

// Function to update user information
const GetSubAccountant = async (subAccountantId, token) => {
    try {
        const response = await fetch(`${API_URL_SubAccountant}/${subAccountantId}`, {
            method: 'GET',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        localStorage.setItem('user', JSON.stringify(data));
        return data;
    } catch (error) {
    }
};

const UploadProfilePhoto = async (token, accountantId, photoFile) => {
    // Prepare a FormData object
    const formData = new FormData();
    formData.append('AccountantId', accountantId);
    formData.append('Photo', photoFile); // The actual file

    try {
        const response = await fetch(`${API_URL}/UploadProfilePhoto`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`
                // Note: Do NOT set "Content-Type" here; 
                // fetch will automatically set the correct boundary for FormData
            },
            body: formData
        });

        // The server returns JSON with { message, url }
        return response; 
    } catch (error) {
        console.error("Error uploading profile photo:", error);
        throw error;
    }
};

// UploadSignature for accountants
const UploadSignature = async (token, accountantId, signatureFile) => {
    // Prepare a FormData object
    const formData = new FormData();
    formData.append('AccountantId', accountantId);
    formData.append('Photo', signatureFile); // The actual file

    try {
        const response = await fetch(`${API_URL}/UploadSignature`, {
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${token}`
                // Note: Do NOT set "Content-Type" here; 
                // fetch will automatically set the correct boundary for FormData
            },
            body: formData
        });

        // The server returns JSON with { message, url }
        return response;
    } catch (error) {
        console.error("Error uploading signature:", error);
        throw error;
    }
};

// GetSignatureUrl for accountants
const GetSignatureUrl = async (token, accountantId, asBase64 = true) => {
    try {
        // Request signature as base64 to avoid CORS issues
        const response = await fetch(`${API_URL}/GetSignatureUrl/${accountantId}?asBase64=${asBase64}`, {
            method: 'GET',
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                return null; // Signature not found
            }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data.url; // Returns base64 data URL or presigned URL
    } catch (error) {
        console.error("Error getting signature URL:", error);
        throw error;
    }
};

const addClientForXtramAccountant = async (clientData) => {

    const response = await fetch(`${API_URL}/CreateClientForXtramAccountant`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(clientData),
    });

    if (!response.ok) {
        const errorBody = await response.text(); // Get the response text
        throw new Error(`Failed to add client: ${errorBody}`);
    }

    return response;
};

// New method to get user details by ID and type
const GetUserDetails = async (userId, userType, authToken) => {
    const API_URL_Users = `${config[selectedEnvironment].API_URL}/Users`;
    const response = await fetch(`${API_URL_Users}/details/${userId}?userType=${userType}`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${authToken}`,
            "Content-Type": "application/json",
        },
    });
    return response;
};


const UserService = {
    getCurrentUser,
    getCurrentToken,
    UpdateUser,
    addClient,
    EditUser,
    addSubAccountant,
    getCurrentUserType,
    EditSubAccountant,
    GetSubAccountant,
    UploadProfilePhoto,
    UploadSignature,
    GetSignatureUrl,
    addClientForXtramAccountant,
    GetUserDetails
    
};
export default UserService;

